import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import { setSearchTerm } from '../../../redux/actions/search';
import Style from '../../../styles/common';

const SearchInput = styled('span')`
  position: relative;
  
  &::before {
    color: ${Style.color.searchIcon};
    content: "\\f002";
    font-family: 'FontAwesome';
    left: 1rem;
    position: absolute;
    top: 0.75rem;
  }
`;

const SearchInputField = styled('input')`
  background-color: ${Style.color.SEARCH_BAR_BACKGROUND};
  border: 0;
  border-radius: 22px;
  box-shadow: inset 0 2px 1px 1px ${Style.color.inputShadow};
  color: ${Style.color.activeText};
  min-width: 20rem;
  outline: 0;
  padding: 0.7rem 0 0.7rem 2.75rem;
`;

class SearchBar extends React.Component {
  static propTypes = {
    searchTerm: PropTypes.string,
    setSearchTerm: PropTypes.func,
  };

  static defaultProps = {
    searchTerm: '',
    setSearchTerm: () => {},
  };

  render() {
    return (
      <SearchInput>
        <SearchInputField
          type="search"
          onChange={event => {
            this.props.setSearchTerm(event.target.value);
          }}
          value={this.props.searchTerm}
        />
      </SearchInput>
    );
  }
}

export default connect(
  state => ({
    searchTerm: state.searchTerm,
  }),
  { setSearchTerm },
)(SearchBar);



// WEBPACK FOOTER //
// ./src/views/Masthead/SearchBar/SearchBar.js